<template>
  <div class="上传组件">
    <el-upload
      class="limit-upload"
      ref="upload"
      action="/uploadFile"
      :show-file-list="true"
      :limit="1"
      :name="name"
      :file-list="fileList"
      :disabled="disabled"
      :multiple="multiple"
      :before-upload="handleBeforeUpload"
      :on-success="(response, file, fileList) => { tryHideFullScreenLoading(); onSuccess(response, file, fileList) }"
      :on-remove="onRemove"
      :accept="accept"
    >
      <slot></slot>
      <!-- <el-button size="small" type="primary">点击上传</el-button>
      <p v-if="templateUrl" @click="downloadTemplate" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p> -->
      <div slot="tip" class="el-upload__tip">{{ tipText }}</div>
    </el-upload>
  </div>
</template>

<script>
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';

export default {

  props: {
    onSuccess: Function,
    onRemove: {
      type: Function,
      default: () => { },
    },
    templateUrl: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: 'file',
    },
    beforeUpload: {
      type: Function,
      default: null,
    },
    fileList: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    tipText: {
      type: String,
      default: '只能上传xls/xlsx文件，且不超过1MB!',
    },
    accept: {
      type: String,
      default: '',
    },
  },
  created() {
  },
  methods: {
    downloadTemplate() {
      if (!this.templateUrl) {
        return;
      }
      window.location.href = this.templateUrl;
    },
    showFullScreenLoading,
    tryHideFullScreenLoading,
    handleBeforeUpload(file) {
      const 是否超过限制 = file.size / 1024 / 1024 < 1;
      if (!是否超过限制) {
        this.$message.show({ text: '上传文件大小不能超过 1MB!', type: 'warning' });
        return false;
      }
      if (this.beforeUpload && typeof this.beforeUpload === 'function') {
        return this.beforeUpload(file);
      }
      return true;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/limitUpload.vue